var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    fill: "none",
    viewBox: "0 0 12 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.32227 10.9668C6.50977 10.9668 6.67383 10.8965 6.80859 10.7676L11.3672 6.30859C11.5254 6.15039 11.6074 5.97461 11.6074 5.76953C11.6074 5.56445 11.5254 5.37695 11.3613 5.22461L6.80273 0.771484C6.67383 0.642578 6.50977 0.572266 6.32227 0.572266C5.92969 0.572266 5.61914 0.876953 5.61914 1.26367C5.61914 1.45117 5.70117 1.63281 5.83594 1.76758L9.9375 5.76367L5.83594 9.77148C5.70117 9.90625 5.61914 10.082 5.61914 10.2754C5.61914 10.6621 5.92969 10.9668 6.32227 10.9668ZM1.08398 10.9668C1.27734 10.9668 1.43555 10.8965 1.57031 10.7676L6.12891 6.30859C6.29297 6.15039 6.36914 5.97461 6.36914 5.76953C6.36914 5.56445 6.28711 5.37695 6.12891 5.22461L1.57031 0.771484C1.43555 0.642578 1.27734 0.572266 1.08398 0.572266C0.691406 0.572266 0.386719 0.876953 0.386719 1.26367C0.386719 1.45117 0.462891 1.63281 0.597656 1.76758L4.70508 5.76367L0.597656 9.77148C0.46875 9.90625 0.386719 10.082 0.386719 10.2754C0.386719 10.6621 0.691406 10.9668 1.08398 10.9668Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowRight);
export default __webpack_public_path__ + "static/media/double-arrow-right.32adf9a49a25e0108aaffd02e8f8bc14.svg";
export { ForwardRef as ReactComponent };